import {
    EnumeratorFilterItemDto,
    VehicleFilterType,
} from "@/shared/api-contract/api-contract";
import { Model, Prop, Vue } from "vue-property-decorator";
import OurCarsCheckBoxList from "@/shared/vehicles/left-filter/checkbox-list/enum-checkbox-list.vue";
import { Options, setup } from "vue-class-component";
import "./check-box-list.scss";
import { useI18n } from "@/shared/composables/use-i18n";
import { filterIconName } from "@/core/utils/filter-icon-name";

type CheckBoxListType =
    | VehicleFilterType.fueltype
    | VehicleFilterType.brand
    | VehicleFilterType.model
    | VehicleFilterType.gearbox
    | VehicleFilterType.condition
    | VehicleFilterType.availability;

@Options({
    components: {
        "our-cars-check-box-list": OurCarsCheckBoxList,
    },
})
export class CheckBoxList extends Vue {
    @Prop({ required: true })
    type!: CheckBoxListType;
    @Model("modelValue", { required: true })
    model!: readonly string[];
    @Prop({ type: Array, required: true })
    options!: EnumeratorFilterItemDto[];

    @Prop({ type: Boolean, default: false })
    selectMode!: boolean;

    @Prop({ type: Number })
    selectModeForMainFilter?: 1 | 2 | 3 | 4;

    @Model("selected")
    selectedModel!: boolean;

    isOpen = false;
    i18n = setup(useI18n);

    get iconName() {
        // TODO такой же компонент для колорс  - colors-list
        return filterIconName(this.type);
    }

    get filterClasses() {
        return {
            selected: this.selectMode && this.selectedModel,
            fill: [
                VehicleFilterType.gearbox,
                VehicleFilterType.brand,
                VehicleFilterType.fueltype,
            ].includes(this.type),
            stroke: [
                VehicleFilterType.availability,
                VehicleFilterType.condition,
                VehicleFilterType.model,
            ].includes(this.type),
        };
    }

    buttonClick(event: UIEvent) {
        if (this.selectMode) {
            const target = event.target;
            const innerButtonClick =
                target instanceof Element && target.closest(".filter-btn__block");
            if (!innerButtonClick) {
                this.selectedModel = !this.selectedModel;
            }
        } else {
            this.isOpen = !this.isOpen;
        }
    }

    innerButtonClick() {
        if (this.selectMode) {
            this.isOpen = !this.isOpen;
        }
    }
}
